var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.4,
    height: 30.607,
    viewBox: "0 0 30.4 30.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #424242;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger_icon",
    transform: "translate(-4117.5 -3410)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    className: "cls-1",
    d: "M34.333,44.5H15.778A2.3,2.3,0,0,0,13.5,46.778h0a2.3,2.3,0,0,0,2.278,2.278h18.6a2.3,2.3,0,0,0,2.278-2.278h0A2.307,2.307,0,0,0,34.333,44.5Z",
    transform: "translate(4104 3378.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    className: "cls-1",
    d: "M41.581,13h-25.8A2.3,2.3,0,0,0,13.5,15.278h0a2.3,2.3,0,0,0,2.278,2.278H41.622A2.3,2.3,0,0,0,43.9,15.278h0A2.334,2.334,0,0,0,41.581,13Z",
    transform: "translate(4104 3397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    className: "cls-1",
    d: "M41.581,75.9h-25.8A2.3,2.3,0,0,0,13.5,78.178h0a2.3,2.3,0,0,0,2.278,2.278H41.622A2.3,2.3,0,0,0,43.9,78.178h0A2.334,2.334,0,0,0,41.581,75.9Z",
    transform: "translate(4104 3360.151)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger_icon.5ec179016036e14bd384fb0da63e39eb.svg";
export { ForwardRef as ReactComponent };